import axios from 'axios';
import { lenientParse, checkValidityBeforeSave, createDateAsUTC } from '../../services/items';

export const getAutoformTableData = async ({
    tableId,
    parameters,
    selectedParentRecordId,
    pageSize,
    page,
    cancelToken,
    sortData,
    filters,
}) => {
    const params = new URLSearchParams();
    if (selectedParentRecordId) {
        params.append('parentRecordId', selectedParentRecordId);
    }
    parameters.forEach((parameterValue) => {
        params.append('parameters', parameterValue);
    });
    // TODO: Include the proper parameters
    const response = await axios.post(
        `/auto-forms/tables/${tableId}/records/get`,
        {
            page,
            pageSize,
            sortData,
            filters,
        },
        {
            params,
            cancelToken,
        }
    );

    return response.data;
};

export const saveAutoformRecords = async ({ tableId, records, parameters }) => {
    const params = new URLSearchParams();
    parameters.forEach((parameterValue) => {
        params.append('parameters', parameterValue);
    });
    const response = await axios.put(`/auto-forms/tables/${tableId}/records`, records);

    return response.data;
};

export const copyAutoformRecords = async ({ itemId }) => {
    const response = await axios.post(`/items/${itemId}/copy`);

    return response.data;
};

export const addItemToPortfolios = (itemId, payload) => axios.post(`/items/${itemId}/portfolios`, payload);

export const saveAutoformTableRow = async ({ schemaCode, tableId, recordId, record }) => {
    const response = await axios.put(`/auto-forms/${schemaCode}/tables/${tableId}/records/${recordId}`, record);

    return response.data;
};

export const deleteAutoformTableRow = async ({ tableId, recordId }) => {
    const response = await axios.delete(`/auto-forms/tables/${tableId}/records/single/${recordId}`);

    return response.data;
};

export const deleteAutoformTableRows = async ({ tableId, recordsIds }) => {
    const response = await axios.delete(`/auto-forms/tables/${tableId}/records/multiple`, { data: { recordsIds } });
    return response.data;
};

export const deleteAutoformGridTable = async ({ tableId, parentRecordId }) => {
    const params = new URLSearchParams();
    if (parentRecordId) {
        params.append('parentRecordId', parentRecordId);
    }
    const response = await axios.delete(`/auto-forms/tables/${tableId}/records/multiple/byparentid`, { params });

    return response.data;
};

export const addSingleAutoformTableRow = async ({ tableId, record, parentRecordId, parameters }) => {
    const params = new URLSearchParams();
    if (parentRecordId) {
        params.append('parentRecordId', parentRecordId);
    }
    parameters.forEach((parameterValue) => {
        params.append('parameters', parameterValue);
    });
    const response = await axios.post(`/auto-forms/tables/${tableId}/records/create/single`, record, { params });

    return response.data;
};
export const addMultipleAutoformTableRow = async ({ tableId, records, parentRecordId, parameters }) => {
    const params = new URLSearchParams();
    if (parentRecordId) {
        params.append('parentRecordId', parentRecordId);
    }
    parameters.forEach((parameterValue) => {
        params.append('parameters', parameterValue);
    });
    const response = await axios.post(`/auto-forms/tables/${tableId}/records/create/multiple`, records, { params });

    return response.data;
};

// TODO: Is this the final table validation or do we need more?
export const getValidRows = (rows, columns) => {
    return rows.map((row) => formatRow(row.data, columns)).filter((row) => row !== null);
};

export const formatRow = (row, columns) => {
    const output = {};
    for (let col in columns) {
        const colData = row[col.name];
        if (col.inputTypeDescription === 'MonthCalendar') {
            if (!checkValidityBeforeSave(colData)) {
                return null;
            } else {
                output[col.name] = createDateAsUTC(lenientParse(colData));
            }
        } else {
            output[col.name] = colData;
        }
    }
    return row;
};

export const refetchSelectedItemBackendData = async ({ tableId, itemId }) => {
    const response = await axios.get(`/auto-forms/tables/${tableId}/records/${itemId}`);

    return response.data;
};
